import Axios from 'axios'
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';

const state = {
  analysisArticlePublish: {
    isBusy: false,
    data: null,
    error: null
  }
};

const getters = {
  articleIsPublished: (state, rootState) => {
    return state.analysisArticlePublish.data;
  },
}

const mutations = {
  LOAD_ANALYSIS_ARTICLE_PUBLISH_BUSY: (state, payload) => {
    state.analysisArticlePublish.isBusy = payload;
  },
  LOAD_ANALYSIS_ARTICLE_PUBLISH_SUCCESS: (state, payload) => {
    state.analysisArticlePublish.data = payload.data.is_published;
    state.analysisArticlePublish.error = null;
  },
  SET_PUBLISH_STATUS: (state, status) => {
    state.analysisArticlePublish.data = status;
  },
  LOAD_ANALYSIS_ARTICLE_PUBLISH_FAIL: (state, payload) => {
    state.analysisArticlePublish.error = payload;
  }
};

const actions = {
  setArticleIsPublished: ({ commit, rootState }, status) => {
    commit('SET_PUBLISH_STATUS', status);
  },  
  publishAnalysisArticle: ({ commit, rootState }, { projectId, articleId, publish }) => {
    return new Promise((resolve, reject) => {
      commit('LOAD_ANALYSIS_ARTICLE_PUBLISH_BUSY', true);
      
      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };
  
      commit('SET_PUBLISH_STATUS', publish.is_published);

      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/publish`;
      
      if (window.location.search) url += window.location.search;
  
      Axios
        .put(url, publish, config)
        .then((response) => {
          commit('LOAD_ANALYSIS_ARTICLE_PUBLISH_SUCCESS', response.data);
          resolve(response.data.data);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')});
  
          console.error(error);
  
          commit('SET_PUBLISH_STATUS', !publish.is_published);
          commit('LOAD_ANALYSIS_ARTICLE_PUBLISH_FAIL', error);
          reject(error)
        })
        .finally(() => commit('LOAD_ANALYSIS_ARTICLE_PUBLISH_BUSY', false));
    });
  }
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};